'use client'

import { useEffect, useRef } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

import { trackMetaPixel } from '@/lib/meta-pixel'

type MetaPixelPageViewProps = {
  enabled: boolean
}

export function MetaPixelPageView({ enabled }: MetaPixelPageViewProps) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const isFirst = useRef(true)
  const search = searchParams?.toString() ?? ''

  useEffect(() => {
    if (!enabled) return
    if (isFirst.current) {
      isFirst.current = false
      return
    }
    trackMetaPixel('PageView')
  }, [enabled, pathname, search])

  return null
}
